import * as S from "./styles";

interface SwitchButtonProps {
  onChange: () => void;
  checked: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  offColor?: string;
}

export function SwitchButton({
  checked,
  onChange,
  disabled = false,
  ariaLabel,
  offColor,
}: SwitchButtonProps) {
  return (
    <S.SwitchStyled
      aria-label={ariaLabel}
      onChange={onChange}
      checked={checked}
      disabled={disabled}
      offColor={offColor}
    />
  );
}
